import { ReactNode } from "react";
import Image, { StaticImageData } from "next/image";
import { Chain } from "@swapkit/core";
import { cva, VariantProps } from "class-variance-authority";

import { formatPrice } from "~/helpers";
import { cn } from "~/services/shadcn";
import { Skeleton } from "../ui";

const iconVariants = cva("h-5 w-5", {
  variants: {
    size: {
      sm: "h-4 w-4",
      default: "h-5 w-5",
      md: "h-6 w-6",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const priceVariants = cva("font-medium", {
  variants: {
    size: {
      sm: "text-sm",
      default: "text-base",
      md: "text-lg",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

type PriceProps = {
  value: ReactNode | number;

  chain?: Chain.THORChain;
  addSuffix?: boolean;

  isLoading?: boolean;
  srcIcon: StaticImageData;
  className?: string;
} & VariantProps<typeof priceVariants & typeof iconVariants>;

export function Price({
  value,
  chain,
  size,
  srcIcon,
  isLoading = false,
  addSuffix,
  className,
}: PriceProps) {
  const assetsByChain = {
    [Chain.THORChain]: {
      // icon: <Image alt="rune" src={runeIcon} className={iconVariants()} />,
      suffix: "RUNE",
    },
  };

  const { suffix } = chain ? assetsByChain[chain] : { suffix: null };

  return (
    <div className={cn("flex flex-shrink-0 items-center space-x-2", className)}>
      <Image alt="rune" src={srcIcon} className={iconVariants()} />

      <Skeleton className="h-7 w-12" active={isLoading}>
        <div className={priceVariants({ size })}>
          {typeof value === "number" ? formatPrice(value) : value}

          {addSuffix && ` ${suffix}`}
        </div>
      </Skeleton>
    </div>
  );
}
